import React from 'react';
import { ReceiptView } from './ReceiptView';

const ReceiptPage = () => {
    const code = sessionStorage.getItem('code');
    const provideCode = sessionStorage.getItem('provideCode');
    return <ReceiptView provideCode={provideCode} code={code} />;
};

export default ReceiptPage;
